// cahce key
export const LOGIN_USER_ENTITY_INFO = "loginUserEntityInfo";
export const SESSION_TOKEN = "sessionToken";
